import React from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { sendStatus } from '../../../store/reducers/status-data';
import { setUserMarketingPreferences } from '../../../store/reducers/account/actions';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { AccountPage } from '../../../templates/account';
import { withSearchParams } from '../../../helpers/navigation/routing';
import { MarketingLists, withCompletedPrevStep, withUser } from '../components';
import { withMarketingListData } from '../hocs/with-marketing-data';

const Component = React.memo(({ values, handleChange, handleSubmit }) => {
  const {
    ACCOUNT: {
      SIGN_UP: {
        title,
        identifier,
        subheading,
        pageHeader,
        marketing: {
          label,
          inPageMessage,
          message,
          heading,
          body,
          legalFooter,
          buttons: { confirm }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      legalFooter={legalFooter}
      onSubmit={handleSubmit}
      pageHeader={pageHeader}
    >
      <MarketingLists label={label} onChange={handleChange} values={values} />
      <ButtonWithIcon buttonType='submit'>{confirm}</ButtonWithIcon>
    </AccountPage>
  );
});

export const SignUpMarketing = compose(
  withUser(),
  withCompletedPrevStep('/account/sign-up'),
  connect(null, { sendStatus, setUserMarketingPreferences }),
  withMarketingListData,
  withState('values', 'setValue', ({ lists, subscribtions }) => {
    return lists.reduce(
      (values, { id, optInDefault }) => ({
        ...values,
        [id]: subscribtions.includes(id) || optInDefault
      }),
      {}
    );
  }),
  withHandlers({
    handleChange:
      ({ setValue }) =>
      (id, checked) => {
        setValue(values => ({ ...values, [id]: checked }));
      },
    handleSubmit:
      ({ values, setUserMarketingPreferences, history }) =>
      () => {
        setUserMarketingPreferences(ObjectShim.truthyKeys(values));
        history.push(withSearchParams('/account/sign-up/account-ready'));
      }
  }),
  lifecycle({
    async componentDidMount() {
      const { sendStatus } = this.props;

      sendStatus('marketingEmails', 'seen');
    }
  })
)(Component);
